
import { Vue, Component } from 'vue-property-decorator';
import SignInCard from '@/features/auth/components/signIn/index.vue';
import NavLogo from '@/features/common/components/navbar/NavLogo.vue';

@Component({
  components: {
    SignInCard,
    NavLogo,
  },
})
export default class SignIn extends Vue {
  created(): void {
    this.$store.commit('setLoading', false);
  }
}
